export default __webpack_public_path__ + "static/media/6B2_12504.a90ed0ca.png";